module.exports = __webpack_public_path__ + "static/media/kg.300e8630.svg";